import { render } from "./PageCrumbHeaderLayout.vue?vue&type=template&id=4da696f0&scoped=true"
import script from "./PageCrumbHeaderLayout.vue?vue&type=script&lang=js"
export * from "./PageCrumbHeaderLayout.vue?vue&type=script&lang=js"

import "./PageCrumbHeaderLayout.vue?vue&type=style&index=0&id=4da696f0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4da696f0"

export default script